import { environment } from '../../environments/environment';

declare global {
  interface Window {
    __env?: {
      apiUrl?: string;
      aadClientId?: string;
      aadAuthority?: string;
      aadApiScope?: string;
    };
  }
}

/**
 * The API URL the container injects into env.js at startup (see server.mts in
 * apps/ai-ui/Dockerfile) takes priority over the build-time environment.ts value,
 * so ops can repoint the UI at a different API by changing a container app env
 * var instead of rebuilding and redeploying the image.
 */
export function getApiUrl(): string {
  return window.__env?.apiUrl || environment.apiUrl;
}

export interface IAuthRuntimeConfig {
  readonly clientId: string;
  readonly authority: string;
  readonly apiScopes: string[];
}

/**
 * Entra settings, with the same runtime-override story as the API URL: the
 * build-time values are correct for every environment today (one app
 * registration serves dev and prod), and the env.js override exists so a tenant
 * or audience change does not require an image rebuild.
 */
export function getAuthConfig(): IAuthRuntimeConfig {
  const env = window.__env;

  return {
    clientId: env?.aadClientId || environment.auth.clientId,
    authority: env?.aadAuthority || environment.auth.authority,
    apiScopes: [env?.aadApiScope || environment.auth.apiScope],
  };
}
